// @flow

import { observer } from "mobx-react";
import React from "react";
import User from "app/models/User";

import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";

import "./UserCard.scss";

type Props = {
    user: User
};

@observer
export default class UserCard extends React.Component<Props> {
    render() {
        const user = this.props.user;

        return (
            <div className="UserCard clearfix">
                <a href={"/u/" + user.profile_slug}>
                    <UserThumbnail
                        name={user.name}
                        image={user.profile_image}
                    />

                    <div className="UserCard__content">
                        <div className="UserCard__name">{user.name}</div>
                        <div className="UserCard__email">{user.email}</div>
                    </div>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/UserCard/UserCard.js